module.exports = __webpack_public_path__ + "media/images/application/template/map-cluster-markers/m3-c5a1da1443e03894c4a8350789d60f5c.png";